import axios from "axios";
import { API_BASE_URL,API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
    return localStorage.getItem("token");
}

export const getAllSecondaryDeploymentInchargeMaster = async () => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `SecondaryDeployment/GetAllSecondaryDeploymentIncharge`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        return response.data;

    } catch (error) {
        throw error
    }
}

export const createDeploymentInchargeMaster = async (inchargeData) => {
    try {
        const response = await axiosInstance.post(API_BASE_URL1 + `SecondaryDeployment/AddNewSecondaryDeploymentIncharge`, inchargeData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

            });
        return response;
    } catch (error) {
        throw error
    }
};

export const updateDeploymentInchargeMaster = async (id, requestData) => {
    try {
        const response = await axiosInstance.put(API_BASE_URL1 + `SecondaryDeployment/UpdateSecondaryDeploymentIncharge`, requestData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

            });
        return response;
    } catch (error) {
        throw error
    }
};

export const getInchargeById = async (id) => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `incharge/getById/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

            });
        // console.log(response, 'response')
        return response;
    } catch (error) {
        throw error
    }
};